'use strict';

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

var _teamMember = require('./team-member');

var _teamMember2 = _interopRequireDefault(_teamMember);

var _teamMembers = require('./team-members');

var _teamMembers2 = _interopRequireDefault(_teamMembers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _model2['default'].extend({

    /**
    */

    mixins: [require('common/models/mixins/model'), require('common/models/mixins/watch-notifications')],

    /**
    */

    apiEndpointAlias: 'team',

    /**
    */

    getMembers: function getMembers(options) {

        var members = _teamMembers2['default'].create({
            user: this.user,
            team: this,
            app: this.app,
            notifier: this.notifier
        });

        members.load();

        return members;
    },

    /**
    */

    onDataChange: function onDataChange(data) {

        this.setProperties({

            // team name
            name: data.name,

            isOwner: !!data.isOwner,

            // might exist
            enterpriseProRateAmount: data.enterpriseProRateAmount,
            enterprisePrice: data.enterprisePrice,
            enterprisePeriod: data.enterprisePeriod,

            // Note that Infinity is proper since we can do conditional operations against it.
            // See addMember() method below (CC)
            maxSize: Number(data.maxTeamSize == void 0 ? Infinity : data.maxTeamSize),

            // minimum team size. Agreed amount when paying for seats (enterprise only)
            minSize: Number(data.minTeamSize || 0),

            // Note that the number of team members can exceed the total number of member objects in the app
            size: data.teamSize || (data.members || []).length
        });
    },

    /**
    */

    toData: function toData() {
        return {
            name: this.name,
            isOwner: this.isOwner,
            enterpriseProRateAmount: this.enterpriseProRateAmount,
            enterprisePrice: this.enterprisePrice,
            enterprisePeriod: this.enterprisePeriod,
            maxTeamSize: this.maxSize,
            minTeamSize: this.minSize,
            teamSize: this.size
        };
    },

    /**
     * notification incomming from some other part of the app
     */

    notify: function notify(message) {
        if (message.apiEndpointAlias === 'teamMembers') {
            if (message.type === 'remove') {
                this.setProperties({ size: this.size - 1 });
            } else if (message.type === 'insert') {
                this.setProperties({ size: this.size + 1 });
            } else if (message.type === 'update') {

                var tm = _teamMember2['default'].create({
                    notifier: this.notifier,
                    data: message.target.data
                });

                if (tm.isUser(this.user)) {
                    this.setProperties({ isOwner: tm.canModifyTeam() });
                }
            }
        }
    },

    /**
    */

    pastTeamMemberLimit: function pastTeamMemberLimit() {
        return this.size >= (this.minSize || this.maxSize || 0);
    },

    /**
    */

    addMember: function addMember(properties) {
        return _teamMember2['default'].create(Object.assign({ notifier: this.notifier }, properties)).save();
    },

    /**
    */

    importTeamMembers: function importTeamMembers(file) {
        // do nothing for now - currently causes redirect
        return file.upload('/home/csvFileImport');
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/team.js
 ** module id = 350
 ** module chunks = 0
 **/